import Validatable from '@/validator/Validatable';

interface IAudienceRuleCustomGroup {
  customgroup_id: number;
  name: string;
  s3_path: string;
  organization_id: number;
  externalsegment_id?: number;
}

export default class AudienceRuleCustomGroup extends Validatable {
  type: string;

  constructor(
    public name: string = '',
    public s3Path: string = '',
    public organizationID?: number,
    public externalSegmentID: number = -1,
    public customGroupID: number = -1,
  ) {
    super();
    this.type = 'AudienceRuleDeviceGroup';
  }

  get isNew(): boolean {
    return this.customGroupID === -1;
  }

  get s3PathFormatted(): string | null {
    if (this.s3Path == null) {
      return null;
    }

    if (this.s3Path.startsWith('s3')) {
      return this.s3Path;
    }

    const url = ['s3://'];
    const path = new URL(this.s3Path);
    const host = path.hostname.split('.s3.');
    if (host.length > 0) {
      url.push(host[0]);
    }
    if (path.pathname != null) {
      url.push(path.pathname);
    }
    return url.join('');
  }

  static fromApi(apiObject: IAudienceRuleCustomGroup): AudienceRuleCustomGroup {
    return new AudienceRuleCustomGroup(
      apiObject.name,
      apiObject.s3_path,
      apiObject.organization_id,
      apiObject.externalsegment_id,
      apiObject.customgroup_id,
    );
  }

  toApi(): IAudienceRuleCustomGroup {
    const apiObject: IAudienceRuleCustomGroup = {
      customgroup_id: this.customGroupID >= 0 ? this.customGroupID : -1,
      name: this.name,
      s3_path: this.s3PathFormatted,
      organization_id: this.organizationID,
    };
    if (this.externalSegmentID >= 0) {
      apiObject.externalsegment_id = this.externalSegmentID;
    }
    return apiObject;
  }
}
